import {Hydra, HydraInterface} from './hydra';

export interface HydraCollectionInterface extends HydraInterface
{
    'hydra:totalItems'?: number;
}

export class HydraCollection extends Hydra implements HydraCollectionInterface{
    [hydra: string]: any;

    constructor(options: {} = null) {
        super();
        if (options) {
            Object.assign(this, options);
            this.initNgxCollection();
        }
    }

    public getMember<T = any[]>(key: string = 'hydra:member'): T {
        if (this[key] !== undefined && this[key] != null) {
            return this[key];
        } else {
            return [] as any;
        }
    }

    public setMember(array: any[] = []) {
        this['hydra:member'] = [...array];
        this['hydra:ngx'] = [...this['hydra:member']];
    }

    hasNextPage(): boolean
    {
        const view = this.getHydraView();
        return (view['hydra:next'] ?? false) !== false;
    }

    getHydraView(): unknown | null
    {
        return this['hydra:view'] ?? null;
    }

    // Manage item with reset memory points for Javascript Motors
    public deleteItem(id: number) {
        // TODO: Modification a verifier car la valeur de retour des splice est l'élément supprimé
        for (let i = 0; i < this['hydra:member'].length; i++) {
            if (this['hydra:member'][i].hasOwnProperty('id')) {
                if (this['hydra:member'][i].id === id) {
                    [...this['hydra:member'].splice(i, 1)];

                    this['hydra:member'] = [...this['hydra:member']];
                    break;
                }
            } else if (this['hydra:member'][i].hasOwnProperty('@id')){
                if (this['hydra:member'][i]['@id'] === id) {
                    [...this['hydra:member'].splice(i, 1)];

                    this['hydra:member'] = [...this['hydra:member']];
                    break;
                }
            }
        }
        for (let x = 0; x < this['hydra:ngx'].length; x++) {
            if (this['hydra:ngx'][x].hasOwnProperty('id')) {
                if (this['hydra:ngx'][x].id === id) {
                    [...this['hydra:ngx'].splice(x, 1)];
                    this['hydra:ngx'] = [...this['hydra:ngx']];
                    break;
                }
            } else if (this['hydra:ngx'][x].hasOwnProperty('@id')) {
                if (this['hydra:ngx'][x]['@id'] === id) {
                    [...this['hydra:ngx'].splice(x, 1)];
                    this['hydra:ngx'] = [...this['hydra:ngx']];
                    break;
                }
            }
        }
    }

    public updateItem(item) {
        if (item.hasOwnProperty('id')) {
            for (let i = 0; i < this['hydra:member'].length; i++) {
                if (this['hydra:member'][i].id === item.id) {
                    this['hydra:member'][i] = {...item};
                    break;
                }
            }
            for (let i = 0; i < this['hydra:ngx'].length; i++) {
                if (this['hydra:ngx'][i].id === item.id) {
                    this['hydra:ngx'][i] = {...item};
                    break;
                }
            }
            this['hydra:ngx'] = [...this['hydra:ngx']];
        } else if(item.hasOwnProperty('@id')) {
            for (let i = 0; i < this['hydra:member'].length; i++) {
                if (this['hydra:member'][i]['@id'] === item['@id']) {
                    this['hydra:member'][i] = {...item};
                    break;
                }
            }
            for (let i = 0; i < this['hydra:ngx'].length; i++) {
                if (this['hydra:ngx'][i]['@id'] === item['@id']) {
                    this['hydra:ngx'][i] = {...item};
                    break;
                }
            }
            this['hydra:ngx'] = [...this['hydra:ngx']];
        } else {
            throw `/!\ - Item without ID - updateItem`;
        }
    }

    public addItem(item) {
        if (item.hasOwnProperty('id') || item.hasOwnProperty('@id')) {
            // TODO: A verifier Modification car la valeur de retour des push est le nouveau length
            // this['hydra:member'] = [...this['hydra:member'].push(item)];
            if (this['hydra:member'] === undefined) {
                this['hydra:member'] = [];
            }
            this['hydra:member'].push(item);
            this['hydra:member'] = [...this['hydra:member']];

            // this['hydra:ngx'] = [...this['hydra:ngx'].push(item)];
            if (this['hydra:ngx'] === undefined) {
                this['hydra:ngx'] = [];
            }
            this['hydra:ngx'].push(item);
            this['hydra:ngx'] = [...this['hydra:ngx']];
        } else {
            throw `/!\ - Item without ID - addItem`;
        }
    }

    // NGX DATA MANAGEMENT
    public initNgxCollection() {
        if (this['hydra:member'] !== undefined && this['hydra:member'] != null) {
            this['hydra:ngx'] = [...this['hydra:member']];
        } else {
            this['hydra:member'] = [];
            this['hydra:ngx'] = [];
        }
    }

    public getNgx(): any[] {
        return this.getMember('hydra:ngx');
    }

    public setNgx(array: any[]) {
        this['hydra:ngx'] = [...array];
    }
}
